/* eslint-disable react/jsx-no-duplicate-props */
import React from "react";
import "../../../../app/custom.scss";
import SplitAggregateChart from "../../../workspace/AggregateChart/SplitAggregateChart";
import { useSelector } from "react-redux";
import NoData from "../../../../assets/no_date.svg";
import VennChart from "../../../utils/charts/VennChart";
import HighCharts from "../../../utils/charts/HighCharts/index";
import NoGraphData from "../../../workspace/DisplayChart/NoGraphData";
import BubbleChart from "../../../utils/charts/d3Graphs/BubbleChart";
import MapGraph from "../../../utils/charts/d3Graphs/MapGraph";
import ErrorBoundary from "../../../../ErrorBoundary";
import WidgetHeader from "./Header";
import uuid from "react-uuid";
const ThreeSplitWidget = ({
  chartStyles_New,
  data,
  splitFinalObj,
  widgetObj,
  widget_index,
  section_index,
  template_widget,
  sections,
  section,
  isdownload,
}) => {
  const errorCode = useSelector((state) => state.Workspace.errorCode);
  const allAttributes = useSelector(
    (state) => state?.attributes?.allAttributes
  );
  const Section = useSelector((state) => state.Section.addSection);
  return (
    <div>
      {typeof data === "object" ? (
        <>
          {data?.graph_type === "aggregate" && data?.datatype !== "int" && (
            <div
              className={`bg__white box-shadow ${
                Section[0]?.isWidgetAdded || Section[0]?.isSectionAdded
                  ? "mb-15"
                  : ""
              }`}
            >
              <WidgetHeader
                type={data?.type}
                
                
                widget_name={data?.widget_name}
                section_id={widgetObj?.section_id}
                widget_id={widgetObj?.widget_id}
                widget_index={widgetObj?.widget_index}
                section_index={widgetObj?.section_index}
                graph_type={widgetObj?.graphData?.graph_type}
                widgets={widgetObj?.widgets}
                template_widget={widgetObj?.template_widget}
                dashboard={widgetObj?.dashboard}
                sections={sections}
              />
              <div className="row ml-0 pl-15">
                {Array.isArray(data?.data) ? (
                  data?.data?.map((item, i) => {
                    return (
                      <div className="col-12 col-md-4 col-lg-4 pl-0" key={i}>
                        <p className="two-split-graph-header pl-15 pt-15">
                          {allAttributes &&
                            allAttributes[data?.splits?.attribute]}
                          <span className="two-split-graph-title">
                            {item.compare_key}
                          </span>
                        </p>
                        <div
                          className={`mb-15 ${
                            i === 2 ? "mr-15" : ""
                          } border-radius-0 three-split-graph`}
                        >
                          <ErrorBoundary chart={true}>
                            <SplitAggregateChart
                              splitFinalObj={splitFinalObj}
                              data={item.data}
                              AllDAta={item}
                              columns={3}
                              datatype={data.datatype}
                              description={item?.description}
                              isdownload={isdownload}
                              splitcolumncount={3}
                            />
                          </ErrorBoundary>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="portlet__body align-items-center p-15 col-12">
                    <ErrorBoundary>
                      <NoGraphData errorCode={errorCode} />
                    </ErrorBoundary>
                  </div>
                )}
              </div>
            </div>
          )}

          {data?.graph_type === "bar" && data?.stacked === false && (
            <div
              className={`bg__white box-shadow ${
                Section[0]?.isWidgetAdded || Section[0]?.isSectionAdded
                  ? "mb-15"
                  : ""
              }`}
            >
              <WidgetHeader
                type={data?.type}
                
                
                widget_name={data?.widget_name}
                section_id={widgetObj?.section_id}
                widget_id={widgetObj?.widget_id}
                widget_index={widgetObj?.widget_index}
                section_index={widgetObj?.section_index}
                graph_type={widgetObj?.graphData?.graph_type}
                widgets={widgetObj?.widgets}
                template_widget={widgetObj?.template_widget}
                dashboard={widgetObj?.dashboard}
                sections={sections}
              />
              <div className="row ml-0">
                {Array.isArray(data?.data) ? (
                  data?.data?.map((item, i) => {
                    return (
                      <div
                      className={`col-12 col-md-4 col-lg-4 pl-0 pr-0 ${i===2?'':'border-right'}`}
                      key={i}
                      >
                        <p className="two-split-graph-header pl-15 pt-15">
                          {allAttributes &&
                            allAttributes[data?.splits?.attribute]}
                          <span className="two-split-graph-title">
                            {item.compare_key}
                          </span>
                        </p>

                        {typeof item?.data === "boolean" ? (
                          <div className="border-radius-0 h-100-42 d-flex align-items-center mb-15 mr-15">
                            <div className="w-100 text-center">
                              <div className="portlet_images mb-15">
                                <img alt="no data" src={NoData} />
                              </div>
                              <div className="text_regular">
                                {item?.description ? item?.description : "No Data Found"}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="mr-15 border-radius-0 box-shadow-none">
                            <ErrorBoundary chart={true}>
                              <HighCharts
                                single={item?.data}
                                style={chartStyles_New}
                                
                                compare_key={item?.compare_key}
                                log={item.log}
                                xaxis={data.x_label}
                                yaxis={data.y_label}
                                split="split"
                                stacked={data?.stacked}
                                type="bar"
                                id={`${widget_index.toString()}${i.toString()}`}
                                dashboard={true}
                                widget_index={widgetObj?.widget_index}
                                section_index={widgetObj?.section_index}
                                PdfDownloadStatus={isdownload}
                                template_widget={template_widget}
                              />
                            </ErrorBoundary>

                            {/* <div className="d-flex pl-15 pr-15 align-items-start justify-content-center mt-15 mb-15">
                              <img
                                src={informationButton}
                                alt="information Button"
                                className="mr-1"
                              />
                              <div
                                className="graph-description"
                                dangerouslySetInnerHTML={{
                                  __html: item?.description,
                                }}
                              />{" "}
                            </div> */}
                          </div>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <div className="portlet__body align-items-center p-15 col-12">
                    <ErrorBoundary>
                      <NoGraphData errorCode={errorCode} />
                    </ErrorBoundary>
                  </div>
                )}
              </div>
            </div>
          )}
          {data?.graph_type === "bar" && data?.stacked === true && (
            <div
              className={`bg__white box-shadow ${
                Section[0]?.isWidgetAdded || Section[0]?.isSectionAdded
                  ? "mb-15"
                  : ""
              }`}
            >
              <WidgetHeader
                type={data?.type}
                
                
                widget_name={data?.widget_name}
                section_id={widgetObj?.section_id}
                widget_id={widgetObj?.widget_id}
                widget_index={widgetObj?.widget_index}
                section_index={widgetObj?.section_index}
                graph_type={widgetObj?.graphData?.graph_type}
                widgets={widgetObj?.widgets}
                template_widget={widgetObj?.template_widget}
                dashboard={widgetObj?.dashboard}
                sections={sections}
              />
              <div className="row ml-0">
                {Array.isArray(data?.data) ? (
                  data?.data?.map((item, i) => {
                    return (
                      <div
                      className={`col-12 col-md-4 col-lg-4 pl-0 pr-0 ${i===2?'':'border-right'}`}
                      key={i}
                      >
                        <p className="two-split-graph-header pl-15 pt-15">
                          {allAttributes &&
                            allAttributes[data?.splits?.attribute]}
                          <span className="two-split-graph-title">
                            {item.compare_key}
                          </span>
                        </p>
                        {typeof item?.data === "boolean" ? (
                          <div className="border-radius-0 h-100-42 d-flex align-items-center mb-15 mr-15">
                            <div className="w-100 text-center">
                              <div className="portlet_images mb-15">
                                <img alt="no data" src={NoData} />
                              </div>
                              <div className="text_regular">
                              {item?.description ? item?.description : "No Data Found"}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="mr-15 border-radius-0 box-shadow-none">
                            <ErrorBoundary chart={true}>
                              <HighCharts
                                single={[item.data]}
                                style={chartStyles_New}
                                
                                compare_key={item?.compare_key}
                                log={item.log}
                                percent={data.percent}
                                xaxis={data.x_label}
                                yaxis={data.y_label}
                                split="split"
                                type="bar"
                                stacked={true}
                                id={`${widget_index.toString()}${i.toString()}`}
                                dashboard={true}
                                widget_index={widgetObj?.widget_index}
                                section_index={widgetObj?.section_index}
                                PdfDownloadStatus={isdownload}
                                template_widget={template_widget}
                              />
                            </ErrorBoundary>

                            {/* <div className="d-flex pl-15 pr-15 align-items-start justify-content-center mt-15 mb-15">
                              <img
                                src={informationButton}
                                alt="information Button"
                                className="mr-1"
                              />
                              <div
                                className="graph-description"
                                dangerouslySetInnerHTML={{
                                  __html: item?.description,
                                }}
                              />
                            </div> */}
                          </div>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <div className="portlet__body align-items-center p-15 col-12">
                    <ErrorBoundary>
                      <NoGraphData errorCode={errorCode} />
                    </ErrorBoundary>
                  </div>
                )}
              </div>
            </div>
          )}

          {data?.graph_type === "line" && (
            <div
              className={`bg__white box-shadow ${
                Section[0]?.isWidgetAdded || Section[0]?.isSectionAdded
                  ? "mb-15"
                  : ""
              }`}
            >
              <WidgetHeader
                type={data?.type}
                
                
                widget_name={data?.widget_name}
                section_id={widgetObj?.section_id}
                widget_id={widgetObj?.widget_id}
                widget_index={widgetObj?.widget_index}
                section_index={widgetObj?.section_index}
                graph_type={widgetObj?.graphData?.graph_type}
                widgets={widgetObj?.widgets}
                template_widget={widgetObj?.template_widget}
                dashboard={widgetObj?.dashboard}
                sections={sections}
              />
              <div className="row ml-0">
                {Array.isArray(data?.data) ? (
                  data?.data?.map((item, i) => {
                    return (
                      <div
                      className={`col-12 col-md-4 col-lg-4 pl-0 pr-0 ${i===2?'':'border-right'}`}
                      key={i}
                      >
                        <p className="two-split-graph-header pl-15 pt-15">
                          {allAttributes &&
                            allAttributes[data?.splits?.attribute]}
                          <span className="two-split-graph-title">
                            {item.compare_key}
                          </span>
                        </p>
                        {typeof item?.data === "boolean" ? (
                          <div className="border-radius-0 h-100-42 d-flex align-items-center mb-15 mr-15">
                            <div className="w-100 text-center">
                              <div className="portlet_images mb-15">
                                <img alt="no data" src={NoData} />
                              </div>
                              <div className="text_regular">
                              {item?.description ? item?.description : "No Data Found"}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="mr-15 border-radius-0 box-shadow-none">
                            <ErrorBoundary chart={true}>
                              <HighCharts
                                single={[item.data]}
                                style={chartStyles_New}
                                
                                compare_key={item?.compare_key}
                                log={item.log}
                                xaxis={data.x_label}
                                yaxis={data.y_label}
                                split="split"
                                type="line"
                                id={`${widget_index.toString()}${i.toString()}`}
                                dashboard={true}
                                widget_index={widgetObj?.widget_index}
                                section_index={widgetObj?.section_index}
                                PdfDownloadStatus={isdownload}
                                template_widget={template_widget}
                              />
                            </ErrorBoundary>

                            {/* <div className="d-flex pl-15 pr-15 align-items-start justify-content-center mt-15 mb-15">
                              <img
                                src={informationButton}
                                alt="information Button"
                                className="mr-1"
                              />
                              <div
                                className="graph-description"
                                dangerouslySetInnerHTML={{
                                  __html: item?.description,
                                }}
                              />
                            </div> */}
                          </div>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <div className="portlet__body align-items-center p-15 col-12">
                    <ErrorBoundary>
                      <NoGraphData errorCode={errorCode} />
                    </ErrorBoundary>
                  </div>
                )}
              </div>
            </div>
          )}
          {data?.graph_type === "area" && (
            <div
              className={`bg__white box-shadow ${
                Section[0]?.isWidgetAdded || Section[0]?.isSectionAdded
                  ? "mb-15"
                  : ""
              }`}
            >
              <WidgetHeader
                type={data?.type}
                
                
                widget_name={data?.widget_name}
                section_id={widgetObj?.section_id}
                widget_id={widgetObj?.widget_id}
                widget_index={widgetObj?.widget_index}
                section_index={widgetObj?.section_index}
                graph_type={widgetObj?.graphData?.graph_type}
                widgets={widgetObj?.widgets}
                template_widget={widgetObj?.template_widget}
                dashboard={widgetObj?.dashboard}
                sections={sections}
              />
              <div className="row ml-0">
                {Array.isArray(data?.data) ? (
                  data?.data?.map((item, i) => {
                    return (
                      <div
                      className={`col-12 col-md-4 col-lg-4 pl-0 pr-0 ${i===2?'':'border-right'}`}
                      key={i}
                      >
                        <p className="two-split-graph-header pl-15 pt-15">
                          {allAttributes &&
                            allAttributes[data?.splits?.attribute]}
                          <span className="two-split-graph-title">
                            {item.compare_key}
                          </span>
                        </p>
                        {typeof item?.data === "boolean" ? (
                          <div className="border-radius-0 h-100-42 d-flex align-items-center mb-15 mr-15">
                            <div className="w-100 text-center">
                              <div className="portlet_images mb-15">
                                <img alt="no data" src={NoData} />
                              </div>
                              <div className="text_regular">
                              {item?.description ? item?.description : "No Data Found"}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="mr-15 border-radius-0 box-shadow-none">
                            <ErrorBoundary chart={true}>
                              <HighCharts
                                single={item.data}
                                style={chartStyles_New}
                                
                                compare_key={item?.compare_key}
                                log={item.log}
                                xaxis={data.x_label}
                                yaxis={data.y_label}
                                split="split"
                                type="area"
                                id={`${widget_index.toString()}${i.toString()}`}
                                dashboard={true}
                                widget_index={widgetObj?.widget_index}
                                section_index={widgetObj?.section_index}
                                PdfDownloadStatus={isdownload}
                                template_widget={template_widget}
                              />
                            </ErrorBoundary>

                            {/* <div className="d-flex pl-15 pr-15 align-items-start justify-content-center mt-15 mb-15">
                              <img
                                src={informationButton}
                                alt="information Button"
                                className="mr-1"
                              />
                              <div
                                className="graph-description"
                                dangerouslySetInnerHTML={{
                                  __html: item?.description,
                                }}
                              />
                            </div> */}
                          </div>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <div className="portlet__body align-items-center p-15 col-12">
                    <ErrorBoundary>
                      <NoGraphData errorCode={errorCode} />
                    </ErrorBoundary>
                  </div>
                )}
              </div>
            </div>
          )}
          {data?.graph_type === "pie" && (
            <div
              className={`bg__white box-shadow ${
                Section[0]?.isWidgetAdded || Section[0]?.isSectionAdded
                  ? "mb-15"
                  : ""
              }`}
            >
              <WidgetHeader
                type={data?.type}
                
                
                widget_name={data?.widget_name}
                section_id={widgetObj?.section_id}
                widget_id={widgetObj?.widget_id}
                widget_index={widgetObj?.widget_index}
                section_index={widgetObj?.section_index}
                graph_type={widgetObj?.graphData?.graph_type}
                widgets={widgetObj?.widgets}
                template_widget={widgetObj?.template_widget}
                dashboard={widgetObj?.dashboard}
                sections={sections}
              />
              <div className="row ml-0">
                {Array.isArray(data?.data) ? (
                  data?.data?.map((item, i) => {
                    return (
                      <div
                      className={`col-12 col-md-4 col-lg-4 pl-0 pr-0 ${i===2?'':'border-right'}`}
                      key={i}
                      >
                        <p className="two-split-graph-header pl-15 pt-15">
                          {allAttributes &&
                            allAttributes[data?.splits?.attribute]}
                          <span className="two-split-graph-title">
                            {item.compare_key}
                          </span>
                        </p>
                        {typeof item?.data === "boolean" ? (
                          <div className="border-radius-0 h-100-42 d-flex align-items-center mb-15 mr-15">
                            <div className="w-100 text-center">
                              <div className="portlet_images mb-15">
                                <img alt="no data" src={NoData} />
                              </div>
                              <div className="text_regular">
                              {item?.description ? item?.description : "No Data Found"}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="mr-15 pl-15 border-radius-0 box-shadow-none">
                            <ErrorBoundary chart={true}>
                              <HighCharts
                                single={item.data}
                                style={chartStyles_New}
                                compare_key={item?.compare_key}
                                type="pie"
                                id={`${widget_index.toString()}${i.toString()}`}
                                dashboard={true}
                                widget_index={widgetObj?.widget_index}
                                section_index={widgetObj?.section_index}
                                PdfDownloadStatus={isdownload}
                                template_widget={template_widget}
                              />
                            </ErrorBoundary>

                            {/* <div className="d-flex pl-15 pr-15 align-items-start justify-content-center mt-15 mb-15">
                              <img
                                src={informationButton}
                                alt="information Button"
                                className="mr-1"
                              />
                              <div
                                className="graph-description"
                                dangerouslySetInnerHTML={{
                                  __html: item?.description,
                                }}
                              />
                            </div> */}
                          </div>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <div className="portlet__body align-items-center p-15 col-12">
                    <ErrorBoundary>
                      <NoGraphData errorCode={errorCode} />
                    </ErrorBoundary>
                  </div>
                )}
              </div>
            </div>
          )}
          {data?.graph_type === "heatmap" && (
            <div
              className={`bg__white box-shadow ${
                Section[0]?.isWidgetAdded || Section[0]?.isSectionAdded
                  ? "mb-15"
                  : ""
              }`}
            >
              <WidgetHeader
                type={data?.type}
                
                
                widget_name={data?.widget_name}
                section_id={widgetObj?.section_id}
                widget_id={widgetObj?.widget_id}
                widget_index={widgetObj?.widget_index}
                section_index={widgetObj?.section_index}
                graph_type={widgetObj?.graphData?.graph_type}
                widgets={widgetObj?.widgets}
                template_widget={widgetObj?.template_widget}
                dashboard={widgetObj?.dashboard}
                sections={sections}
              />
              <div className="row ml-0">
                {Array.isArray(data?.data) ? (
                  data?.data?.map((item, i) => {
                    return (
                      <div
                      className={`col-12 col-md-4 col-lg-4 pl-0 pr-0 ${i===2?'':'border-right'}`}
                      key={i}
                      >
                        <p className="two-split-graph-header pl-15 pt-15">
                          {allAttributes &&
                            allAttributes[data?.splits?.attribute]}
                          <span className="two-split-graph-title">
                            {item.compare_key}
                          </span>
                        </p>
                        {typeof item?.data === "boolean" ? (
                          <div className="border-radius-0 h-100-42 d-flex align-items-center mb-15 mr-15">
                            <div className="w-100 text-center">
                              <div className="portlet_images mb-15">
                                <img alt="no data" src={NoData} />
                              </div>
                              <div className="text_regular">
                              {item?.description ? item?.description : "No Data Found"}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="mr-15 border-radius-0 box-shadow-none">
                            <ErrorBoundary chart={true}>
                              <HighCharts
                                single={item.data}
                                style={chartStyles_New}
                                
                                compare_key={item?.compare_key}
                                log={item.log}
                                xaxis={data.x_label}
                                yaxis={data.y_label}
                                type="heat"
                                id={`${widget_index.toString()}${i.toString()}`}
                                dashboard={true}
                                widget_index={widgetObj?.widget_index}
                                section_index={widgetObj?.section_index}
                                PdfDownloadStatus={isdownload}
                                template_widget={template_widget}
                              />
                            </ErrorBoundary>

                            {/* <div className="d-flex pl-15 pr-15 align-items-start justify-content-center mt-15 mb-15">
                              <img
                                src={informationButton}
                                alt="information Button"
                                className="mr-1"
                              />
                              <div
                                className="graph-description"
                                dangerouslySetInnerHTML={{
                                  __html: item?.description,
                                }}
                              />
                            </div> */}
                          </div>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <div className="portlet__body align-items-center p-15 col-12">
                    <ErrorBoundary>
                      <NoGraphData errorCode={errorCode} />
                    </ErrorBoundary>
                  </div>
                )}
              </div>
            </div>
          )}
          {data?.graph_type === "sunburst" && (
            <div
              className={`bg__white box-shadow ${
                Section[0]?.isWidgetAdded || Section[0]?.isSectionAdded
                  ? "mb-15"
                  : ""
              }`}
            >
              <WidgetHeader
                type={data?.type}
                
                
                widget_name={data?.widget_name}
                section_id={widgetObj?.section_id}
                widget_id={widgetObj?.widget_id}
                widget_index={widgetObj?.widget_index}
                section_index={widgetObj?.section_index}
                graph_type={widgetObj?.graphData?.graph_type}
                widgets={widgetObj?.widgets}
                template_widget={widgetObj?.template_widget}
                dashboard={widgetObj?.dashboard}
                sections={sections}
              />
              <div className="row ml-0">
                {Array.isArray(data?.data) ? (
                  data?.data?.map((item, i) => {
                    return (
                      <div
                      className={`col-12 col-md-4 col-lg-4 pl-0 pr-0 ${i===2?'':'border-right'}`}
                      key={i}
                      >
                        <p className="two-split-graph-header pl-15 pt-15">
                          {allAttributes &&
                            allAttributes[data?.splits?.attribute]}
                          <span className="two-split-graph-title">
                            {item.compare_key}
                          </span>
                        </p>
                        {typeof item?.data === "boolean" ? (
                          <div className="border-radius-0 h-100-42 d-flex align-items-center mb-15 mr-15">
                            <div className="w-100 text-center">
                              <div className="portlet_images mb-15">
                                <img alt="no data" src={NoData} />
                              </div>
                              <div className="text_regular">
                              {item?.description ? item?.description : "No Data Found"}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="mr-15 border-radius-0 box-shadow-none">
                            <ErrorBoundary chart={true}>
                              <HighCharts
                                single={item.data}
                                style={
                                  isdownload === true
                                    ? chartStyles_New
                                    : {
                                        height: "450px",
                                        width: "100%",
                                        margin: "auto",
                                      }
                                }
                                compare_key={item?.compare_key}
                                type="sunburst"
                                id={`${widget_index.toString()}${i.toString()}`}
                                dashboard={true}
                                widget_index={widgetObj?.widget_index}
                                section_index={widgetObj?.section_index}
                                PdfDownloadStatus={isdownload}
                                template_widget={template_widget}
                              />
                            </ErrorBoundary>

                            {/* <div className="d-flex pl-15 pr-15 align-items-start justify-content-center mt-15 mb-15">
                              <img
                                src={informationButton}
                                alt="information Button"
                                className="mr-1"
                              />
                              <div
                                className="graph-description"
                                dangerouslySetInnerHTML={{
                                  __html: item?.description,
                                }}
                              />
                            </div> */}
                          </div>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <div className="portlet__body align-items-center p-15 col-12">
                    <ErrorBoundary>
                      <NoGraphData errorCode={errorCode} />
                    </ErrorBoundary>
                  </div>
                )}
              </div>
            </div>
          )}
          {data?.graph_type === "wordcloud" && (
            <div
              className={`bg__white box-shadow ${
                Section[0]?.isWidgetAdded || Section[0]?.isSectionAdded
                  ? "mb-15"
                  : ""
              }`}
            >
              <WidgetHeader
                type={data?.type}
                
                
                widget_name={data?.widget_name}
                section_id={widgetObj?.section_id}
                widget_id={widgetObj?.widget_id}
                widget_index={widgetObj?.widget_index}
                section_index={widgetObj?.section_index}
                graph_type={widgetObj?.graphData?.graph_type}
                widgets={widgetObj?.widgets}
                template_widget={widgetObj?.template_widget}
                dashboard={widgetObj?.dashboard}
                sections={sections}
              />
              <div className="row ml-0">
                {Array.isArray(data?.data) ? (
                  data?.data?.map((item, i) => {
                    return (
                      <div
                      className={`col-12 col-md-4 col-lg-4 pl-0 pr-0 ${i===2?'':'border-right'}`}
                      key={i}
                      >
                        <p className="two-split-graph-header pl-15 pt-15">
                          {allAttributes &&
                            allAttributes[data?.splits?.attribute]}
                          <span className="two-split-graph-title">
                            {item.compare_key}
                          </span>
                        </p>
                        {typeof item?.data === "boolean" ? (
                          <div className="border-radius-0 h-100-42 d-flex align-items-center mb-15 mr-15">
                            <div className="w-100 text-center">
                              <div className="portlet_images mb-15">
                                <img alt="no data" src={NoData} />
                              </div>
                              <div className="text_regular">
                              {item?.description ? item?.description : "No Data Found"}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="mr-15 border-radius-0 box-shadow-none">
                            <ErrorBoundary chart={true}>
                              <HighCharts
                                single={item?.data}
                                id={`${widget_index.toString()}${i.toString()}`}
                                style={chartStyles_New}
                                xaxis={data?.x_label}
                                yaxis={data?.y_label}
                                widget_index={widgetObj?.widget_index}
                                section_index={widgetObj?.section_index}
                                type={data?.graph_type}
                                splitcolumncount={3}
                                differential={data?.differential}
                                dashboard={true}
                                PdfDownloadStatus={isdownload}
                                template_widget={template_widget}
                              />
                            </ErrorBoundary>
                            {/* <div className="d-flex pl-15 pr-15 align-items-start justify-content-center mt-15 mb-15">
                              <img
                                src={informationButton}
                                alt="information Button"
                                className="mr-1"
                              />
                              <div
                                className="graph-description"
                                dangerouslySetInnerHTML={{
                                  __html: item?.description,
                                }}
                              />
                            </div> */}
                          </div>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <div className="portlet__body align-items-center p-15 col-12">
                    <ErrorBoundary>
                      <NoGraphData errorCode={errorCode} />
                    </ErrorBoundary>
                  </div>
                )}
              </div>
            </div>
          )}
          {data?.graph_type === "map_pie" && (
            <div
              className={`bg__white box-shadow ${
                Section[0]?.isWidgetAdded || Section[0]?.isSectionAdded
                  ? "mb-15"
                  : ""
              }`}
            >
              <WidgetHeader
                type={data?.type}
                
                
                widget_name={widgetObj?.graphData?.widget_name}
                section_id={widgetObj?.section_id}
                widget_id={widgetObj?.widget_id}
                widget_index={widgetObj?.widget_index}
                section_index={widgetObj?.section_index}
                graph_type={widgetObj?.graphData?.graph_type}
                widgets={widgetObj?.widgets}
                template_widget={widgetObj?.template_widget}
                dashboard={widgetObj?.dashboard}
                sections={sections}
              />
              <div className="row ml-0">
                {Array.isArray(data?.data) ? (
                  data?.data?.map((item, i) => {
                    return (
                      <div
                      className={`col-12 col-md-4 col-lg-4 pl-0 pr-0 ${i===2?'':'border-right'}`}
                      key={i}
                      >
                        <p className="two-split-graph-header pl-15 pt-15">
                          {allAttributes &&
                            allAttributes[data?.splits?.attribute]}
                          <span className="two-split-graph-title">
                            {item.compare_key}
                          </span>
                        </p>
                        {typeof item?.data === "boolean" ? (
                          <div className="border-radius-0 h-100-42 d-flex align-items-center mb-15 mr-15">
                            <div className="w-100 text-center">
                              <div className="portlet_images mb-15">
                                <img alt="no data" src={NoData} />
                              </div>
                              <div className="text_regular">
                              {item?.description ? item?.description : "No Data Found"}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="mr-15 border-radius-0 box-shadow-none">
                            <ErrorBoundary chart={true}>
                              <MapGraph
                                single={item?.data}

                                compare_key={item?.compare_key}
                                style={chartStyles_New ? chartStyles_New :{
                                  height: "450px",
                                }}
                                
                              />
                            </ErrorBoundary>

                            {/* <div className="d-flex pl-15 pr-15 align-items-start justify-content-center mt-15 mb-15">
                              <img
                                src={informationButton}
                                alt="information Button"
                                className="mr-1"
                              />
                              <div
                                className="graph-description"
                                dangerouslySetInnerHTML={{
                                  __html: item?.description,
                                }}
                              />
                            </div> */}
                          </div>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <div className="portlet__body align-items-center p-15 col-12">
                    <ErrorBoundary>
                      <NoGraphData errorCode={errorCode} />
                    </ErrorBoundary>
                  </div>
                )}
              </div>
            </div>
          )}
          {data?.graph_type === "bubble" && (
            <div
              className={`bg__white box-shadow ${
                Section[0]?.isWidgetAdded || Section[0]?.isSectionAdded
                  ? "mb-15"
                  : ""
              }`}
            >
              <WidgetHeader
                type={data?.type}
                
                
                widget_name={widgetObj?.widget_name}
                section_id={widgetObj?.section_id}
                widget_id={widgetObj?.widget_id}
                widget_index={widgetObj?.widget_index}
                section_index={widgetObj?.section_index}
                graph_type={widgetObj?.graph_type}
                widgets={widgetObj?.widgets}
                template_widget={widgetObj?.template_widget}
                dashboard={widgetObj?.dashboard}
                sections={sections}
              />
              <div className="row ml-0">
                {Array.isArray(data?.data) ? (
                  data?.data?.map((item, i) => {
                    return (
                      <div
                        className={`col-12 col-md-4 col-lg-4 pl-0 pr-0 ${i===2?'':'border-right'}`}
                        key={`${item?.compare_key}_${i}`}
                      >
                        <p className="two-split-graph-header pl-15 pt-15">
                          {allAttributes &&
                            allAttributes[data?.splits?.attribute]}
                          <span className="two-split-graph-title">
                            {item.compare_key}
                          </span>
                        </p>
                        {typeof item?.data === "boolean" ? (
                          <div className="border-radius-0 h-100-42 d-flex align-items-center mb-15 mr-15">
                            <div className="w-100 text-center">
                              <div className="portlet_images mb-15">
                                <img alt="no data" src={NoData} />
                              </div>
                              <div className="text_regular">
                              {item?.description ? item?.description : "No Data Found"}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="mr-15 border-radius-0 box-shadow-none">
                            <ErrorBoundary chart={true}>
                              <BubbleChart
                                single={item?.data}
                                let
                                uniqueId={uuid()}
                                splitcolumns={3}
                                compare_key={item?.compare_key}
                                style={chartStyles_New}
                                isdownload={isdownload}
                                splitcolumncount={3}
                                widget_index={widgetObj?.widget_index}
                                section_index={widgetObj?.section_index}
                                PdfDownloadStatus={isdownload}
                              />
                            </ErrorBoundary>

                            {/* <div className="d-flex pl-15 pr-15 align-items-start justify-content-center mt-15 mb-15">
                              <img
                                src={informationButton}
                                alt="information Button"
                                className="mr-1"
                              />
                              <div
                                className="graph-description"
                                dangerouslySetInnerHTML={{
                                  __html: item?.description,
                                }}
                              />
                            </div> */}
                          </div>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <div className="portlet__body align-items-center p-15 col-12">
                    <ErrorBoundary>
                      <NoGraphData errorCode={errorCode} />
                    </ErrorBoundary>
                  </div>
                )}
              </div>
            </div>
          )}

          {data?.graph_type === "venn" && (
            <div
              className={`bg__white box-shadow ${
                Section[0]?.isWidgetAdded || Section[0]?.isSectionAdded
                  ? "mb-15"
                  : ""
              }`}
            >
              <WidgetHeader
                type={data?.type}
                
                
                widget_name={widgetObj?.graphData?.widget_name}
                section_id={widgetObj?.section_id}
                widget_id={widgetObj?.widget_id}
                widget_index={widgetObj?.widget_index}
                section_index={widgetObj?.section_index}
                graph_type={widgetObj?.graphData?.graph_type}
                widgets={widgetObj?.widgets}
                template_widget={widgetObj?.template_widget}
                dashboard={widgetObj?.dashboard}
                sections={sections}
              />
              <div className="row ml-0">
                <div className="col-12 col-md-12 pl-0">
                  <div className="mb-15 portlet border-radius-0 box-shadow-none">
                    <ErrorBoundary chart={true}>
                      <VennChart
                        single={data?.data}
                        title={data?.widget_name}
                        colors={data?.colors}
                      />
                    </ErrorBoundary>
                  </div>
                </div>
              </div>
            </div>
          )}

        </>
      ) : (
        (typeof data === "string" || typeof data?.data === "string") && (
          <>
            <WidgetHeader
              type={data?.type}
              
              
              widget_name={
                data?.widget_name
                  ? data?.widget_name
                  : template_widget
                  ? Section[section_index]?.data[widget_index]?.widget_name
                  : sections
                  ? sections[section_index]?.widgets[widget_index]?.widget_name
                  : section[0]?.widgets[widget_index]?.widget_name
              }
              section_id={widgetObj?.section_id}
              widget_id={widgetObj?.widget_id}
              widget_index={widgetObj?.widget_index}
              section_index={widgetObj?.section_index}
              graph_type={widgetObj?.graphData?.graph_type}
              widgets={widgetObj?.widgets}
              template_widget={widgetObj?.template_widget}
              dashboard={widgetObj?.dashboard}
              sections={sections}
            />
            <div className="portlet__body p-15">
              <ErrorBoundary>
                <NoGraphData errorCode={errorCode} />
              </ErrorBoundary>
            </div>
          </>
        )
      )}
    </div>
  );
};

export default ThreeSplitWidget;
